import { Pipe, PipeTransform } from '@angular/core';
import { ConsoleService } from '../services/console.service';
@Pipe({
  name: 'split',
  standalone: true
})
export class SplitPipe implements PipeTransform {

  transform(input:string, sep = ','): any[] {
    ConsoleService.info('input.split',input.split(sep))

    return input.split(sep);
  }

}
